export const LogoMinos = () => {
	return (
		<svg
			width='133'
			height='50'
			viewBox='0 0 133 50'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			aria-hidden
		>
			<path
				d='M41.3455 40.088L39.5131 24.6563L33.3134 37.4881H30.0136L23.7814 24.6888L21.914 40.088H17.8467L20.6465 17.1241H24.1789L31.646 32.9233L39.0781 17.1241H42.6104L45.4103 40.088H41.343H41.3455Z'
				fill='black'
			/>
			<path d='M49.3799 17.1241H53.4472V40.088H49.3799V17.1241Z' fill='black' />
			<path
				d='M75.5786 17.1241V40.088H71.8788L62.7143 24.6238V40.088H58.647V17.1241H62.4793L71.5113 32.4559V17.1241H75.5786Z'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M90.9779 16.8591C84.4132 16.8591 79.3135 22.1239 79.3135 28.6236C79.3135 35.1232 84.4457 40.423 90.9779 40.423C97.5101 40.423 102.642 35.1207 102.642 28.6236C102.642 22.1264 97.5426 16.8591 90.9779 16.8591ZM90.9454 20.659C95.3452 20.659 98.5775 24.2238 98.5775 28.6236C98.5775 33.0208 95.3102 36.5882 90.9454 36.5882C86.5806 36.5882 83.4133 33.0208 83.4133 28.6236C83.4133 24.2263 86.5456 20.659 90.9454 20.659Z'
				fill='black'
			/>
			<path
				d='M105.047 33.3883H109.08C109.112 35.1557 110.812 36.7881 113.347 36.7881C115.679 36.7881 117.179 35.4557 117.179 33.6558C117.179 32.0559 115.812 31.1234 113.879 30.5885L111.012 29.7885C106.08 28.5211 105.212 25.5562 105.212 23.5563C105.212 19.489 108.78 16.8566 113.012 16.8566C117.244 16.8566 120.512 19.4565 120.512 23.7563H116.479C116.479 21.8564 115.047 20.489 112.912 20.489C110.945 20.489 109.312 21.6889 109.312 23.4888C109.312 24.1213 109.512 25.4887 112.145 26.1562L114.877 26.8886C118.477 27.8886 121.244 29.821 121.244 33.4883C121.244 37.6881 117.744 40.4205 113.245 40.4205C108.345 40.4205 105.045 37.2531 105.045 33.3883H105.047Z'
				fill='black'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M122.329 2.21489L130.059 9.997C131.153 11.3069 131.816 12.9944 131.816 14.8318V42.4454C131.816 46.6102 128.426 50 124.261 50H14.8293C12.9919 50 11.3069 49.3375 9.9945 48.2426L2.21239 40.5105C0.784961 39.0855 0 37.1881 0 35.1682V7.55712C0 3.39233 3.38983 0.00249987 7.55462 0H116.987C119.004 0 120.901 0.787461 122.329 2.21489ZM124.259 48.6401C127.676 48.6401 130.453 45.8602 130.453 42.4454L130.456 42.4429V14.8318C130.456 11.4144 127.676 8.63707 124.261 8.63707H14.8293C11.4144 8.63707 8.63707 11.4169 8.63707 14.8318V42.4454C8.63707 45.8627 11.4144 48.6401 14.8293 48.6401H124.259Z'
				fill='black'
			/>
		</svg>
	);
};

export const EmailIcon = ({
	className = '',
	width = '24',
	height = '24',
}: {
	className: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			className={`${className} transition-colors duration-300 ease-out group-hover:transition-colors group-hover:ease-in`}
			fill='currentColor'
			width={width}
			height={height}
			viewBox='0 0 22 23'
			aria-hidden
			pointerEvents='visibilePainted'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M11 22.043C17.0751 22.043 22 17.1181 22 11.043C22 4.96784 17.0751 0.0429688 11 0.0429688C4.92487 0.0429688 0 4.96784 0 11.043C0 17.1181 4.92487 22.043 11 22.043ZM15.5539 6.60547H5.75295C5.41102 6.60547 5.14814 6.71713 4.96398 6.94021C4.77968 7.1634 4.68767 7.44252 4.68767 7.77726C4.68767 8.04764 4.80977 8.34061 5.05384 8.65625C5.29792 8.97176 5.55763 9.21958 5.83286 9.39984C5.98374 9.50293 6.43875 9.80882 7.19788 10.3174C7.60768 10.592 7.96406 10.8314 8.27031 11.0379C8.53134 11.2138 8.75647 11.3662 8.94233 11.4926C8.96291 11.5065 8.99484 11.5286 9.03703 11.5578L9.04177 11.561L9.22538 11.689C9.36963 11.7899 9.48947 11.8714 9.58492 11.9337C9.68024 11.996 9.79572 12.0657 9.9312 12.143C10.0666 12.2201 10.1943 12.2782 10.3141 12.3168C10.434 12.3554 10.5449 12.3748 10.647 12.3748H10.6536H10.6602C10.7623 12.3748 10.8733 12.3554 10.9932 12.3168C11.113 12.2782 11.2406 12.2203 11.376 12.143C11.5114 12.0657 11.6267 11.9959 11.7223 11.9337C11.8178 11.8714 11.9376 11.7899 12.0819 11.689C12.1567 11.6367 12.2174 11.5943 12.2654 11.5611C12.3099 11.5302 12.3435 11.5072 12.3649 11.4926C12.5097 11.3951 12.7354 11.2434 13.0387 11.0397C13.5907 10.6688 14.4037 10.1229 15.481 9.39984C15.8051 9.18099 16.0758 8.91689 16.2933 8.60792C16.5105 8.29894 16.6194 7.97485 16.6194 7.63573C16.6194 7.3524 16.5138 7.10996 16.3031 6.90803C16.0922 6.70636 15.8425 6.60547 15.5539 6.60547ZM5.36007 10.089C5.10711 9.92587 4.88279 9.73909 4.6875 9.5287V14.5025L7.66704 11.6211C7.07096 11.2187 6.30295 10.7086 5.36007 10.089ZM15.5539 15.6714C15.8221 15.6714 16.0545 15.5858 16.2521 15.4167L12.8716 12.1475C12.7905 12.2037 12.7119 12.2583 12.6376 12.3103C12.3846 12.4905 12.1793 12.6311 12.0216 12.7319C11.864 12.8329 11.6543 12.9359 11.3925 13.041C11.1305 13.1463 10.8864 13.1987 10.66 13.1987H10.6533H10.6467C10.4203 13.1987 10.1762 13.1463 9.91422 13.041C9.65225 12.9359 9.44251 12.8329 9.28502 12.7319C9.12738 12.6311 8.92216 12.4905 8.66905 12.3103C8.59852 12.2602 8.5203 12.2054 8.43572 12.1467L5.0546 15.4167C5.25214 15.5858 5.48469 15.6714 5.75288 15.6714H15.5539ZM13.641 11.6223C14.2758 11.1936 15.0466 10.6826 15.9535 10.089C16.2064 9.92151 16.4284 9.73485 16.6193 9.5287V14.5026L13.641 11.6223Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const EmailIconFooter = ({
	className = '',
	width = '16',
	height = '16',
}: {
	className: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			className={`${className} transition-colors duration-300 ease-out group-hover:transition-colors group-hover:ease-in`}
			fill='currentColor'
			width={width}
			height={height}
			viewBox='0 0 16 14'
			aria-hidden
			pointerEvents='visibilePainted'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				fill='currentColor'
				d='M1.42865 0.5H14.5713C14.9582 0.5 15.2931 0.6399 15.5759 0.919554C15.8584 1.19956 16 1.53574 16 1.92863C16 2.39887 15.854 2.84829 15.5628 3.27673C15.271 3.70517 14.9081 4.07139 14.4736 4.37486C13.0289 5.37755 11.9388 6.13453 11.1985 6.64884C10.7917 6.93131 10.4892 7.14166 10.295 7.27676C10.2662 7.29701 10.2212 7.32899 10.1615 7.37187C10.0971 7.41791 10.0157 7.47659 9.91547 7.54913C9.722 7.68906 9.56131 7.80211 9.43332 7.88851C9.30509 7.97472 9.15044 8.07146 8.96894 8.17865C8.78727 8.28587 8.6162 8.36619 8.45553 8.41972C8.29477 8.47323 8.14596 8.50007 8.00911 8.50007H8.00022H7.99133C7.85445 8.50007 7.70566 8.47323 7.54493 8.41972C7.38424 8.36619 7.21302 8.28569 7.03149 8.17865C6.84982 8.07146 6.69496 7.97493 6.56715 7.88851C6.43916 7.80211 6.27846 7.68903 6.08502 7.54913C5.98457 7.47659 5.90315 7.41794 5.8388 7.37173L5.83233 7.3671C5.77582 7.32669 5.73304 7.29611 5.70547 7.27676C5.45623 7.10148 5.15435 6.89027 4.80431 6.64637C4.39365 6.35995 3.91577 6.02804 3.36625 5.64724C2.34829 4.94199 1.73814 4.51781 1.53582 4.37486C1.16675 4.1249 0.818482 3.78125 0.491188 3.34374C0.163894 2.90606 0.000174294 2.49981 0.000174294 2.12488C0.000174294 1.66071 0.123545 1.27366 0.370693 0.964173C0.617638 0.654831 0.970147 0.5 1.42865 0.5ZM0 4.55354C0.261876 4.84528 0.562678 5.10428 0.901882 5.33043C2.16624 6.18964 3.19611 6.89704 3.99542 7.45507L0 11.4505V4.55354ZM15.5075 12.7182C15.2426 12.9527 14.931 13.0715 14.5713 13.0715H1.42863C1.069 13.0715 0.75716 12.9527 0.492263 12.7182L5.02619 8.18379C5.1396 8.26521 5.24449 8.34129 5.33908 8.41063C5.67848 8.6606 5.95366 8.8556 6.16505 8.99536C6.37624 9.13543 6.65749 9.27821 7.00878 9.42397C7.36007 9.56994 7.68736 9.64265 7.99101 9.64265H7.9999H8.00879C8.31241 9.64265 8.6397 9.56991 8.99102 9.42397C9.3421 9.27821 9.62336 9.13543 9.83474 8.99536C10.0462 8.8556 10.3215 8.66057 10.6607 8.41063C10.7603 8.33862 10.8657 8.26289 10.9745 8.18501L15.5075 12.7182ZM15.1072 5.33043C13.891 6.15356 12.8574 6.86218 12.0062 7.45666L16 11.4507V4.55354C15.7439 4.83942 15.4464 5.09824 15.1072 5.33043Z'
			/>
		</svg>
	);
};

export const PhoneIconFooter = ({
	className = '',
	width = '16',
	height = '15',
}: {
	className: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			className={`${className} transition-colors duration-300 ease-out group-hover:transition-colors group-hover:ease-in`}
			fill='currentColor'
			width={width}
			height={height}
			viewBox='0 0 16 15'
			aria-hidden
			pointerEvents='visibilePainted'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				fill='currentColor'
				d='M5.2065 6.17348C4.74687 5.74257 5.60299 4.29293 5.60299 4.29293C5.86549 3.73584 5.73649 2.91022 5.31194 2.44566L3.41078 0.365349C2.98754 -0.0977797 2.27164 -0.12373 1.81392 0.305382L0.504263 1.53319C-0.301403 2.2885 0.00284085 3.73444 0.420546 4.7187C0.420546 4.7187 0.949885 6.36913 5.07807 10.2393C9.20626 14.1095 10.9667 14.6057 10.9667 14.6057C12.0166 14.9973 13.5589 15.2826 14.3646 14.5273L15.6743 13.2994C16.132 12.8703 16.1043 12.1992 15.6103 11.8024L13.3913 10.0201C12.8958 9.62204 12.0151 9.5011 11.4209 9.74719C11.4209 9.74719 9.80698 10.4864 9.34734 10.0555L7.31073 8.14619L5.2065 6.17348Z'
			/>
		</svg>
	);
};

export const ArrowBtn = ({
	className = '',
	width = '22',
}: {
	className?: string;
	width?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={`transition-colors duration-300 ease-in-out group-hover:transition-colors ${className}`}
			fill='currentColor'
			aria-hidden
			width={width}
			height='18'
			viewBox='0 0 22 18'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M21.4142 8.88061L13 0.4664L11.5858 1.88061L17.5857 7.88046H0V9.88046H17.586L11.5858 15.8806L13 17.2948L21.4142 8.88061Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const ArrowLeft = () => {
	return (
		<svg
			className='size-2.5 rtl:rotate-180'
			aria-hidden
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			viewBox='0 0 6 10'
		>
			<path
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='2'
				d='M5 1 1 5l4 4'
			/>
		</svg>
	);
};

// For events
export const ArrowCarret = ({
	className = '',
	width = '15',
}: {
	className?: string;
	width?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height='11'
			viewBox='0 0 5 11'
			fill='none'
			aria-hidden
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5 5.04785L-4.37114e-07 0.0478518L0 10.0479L5 5.04785Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const PersonIcon = ({
	className = '',
	width = '20',
	height = '21',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 20 21'
			fill='currentColor'
			aria-hidden
		>
			<path
				d='M13.646 10.7155C14.6264 9.94415 15.342 8.88642 15.6933 7.68944C16.0445 6.49246 16.014 5.21576 15.6058 4.03696C15.1977 2.85817 14.4323 1.83589 13.4161 1.11235C12.3999 0.388815 11.1835 0 9.93603 0C8.68858 0 7.47215 0.388815 6.45596 1.11235C5.43978 1.83589 4.67438 2.85817 4.26624 4.03696C3.85811 5.21576 3.82754 6.49246 4.17879 7.68944C4.53004 8.88642 5.24564 9.94415 6.22603 10.7155C4.54611 11.3885 3.08032 12.5048 1.98492 13.9454C0.88953 15.386 0.205595 17.0968 0.00603184 18.8955C-0.00841357 19.0268 0.00314838 19.1597 0.0400573 19.2866C0.0769662 19.4134 0.138499 19.5317 0.221143 19.6348C0.388051 19.843 0.630815 19.9763 0.896032 20.0055C1.16125 20.0347 1.42719 19.9573 1.63536 19.7904C1.84352 19.6235 1.97686 19.3807 2.00603 19.1155C2.22562 17.1607 3.15772 15.3553 4.62425 14.0443C6.09078 12.7333 7.98893 12.0085 9.95603 12.0085C11.9231 12.0085 13.8213 12.7333 15.2878 14.0443C16.7543 15.3553 17.6864 17.1607 17.906 19.1155C17.9332 19.3612 18.0505 19.5882 18.2351 19.7525C18.4198 19.9169 18.6588 20.007 18.906 20.0055H19.016C19.2782 19.9753 19.5178 19.8428 19.6826 19.6367C19.8474 19.4307 19.9241 19.1679 19.896 18.9055C19.6955 17.1017 19.0079 15.3865 17.9069 13.9437C16.8059 12.5009 15.3329 11.385 13.646 10.7155ZM9.93603 10.0055C9.14491 10.0055 8.37155 9.7709 7.71375 9.33137C7.05595 8.89185 6.54326 8.26713 6.24051 7.53623C5.93776 6.80533 5.85855 6.00106 6.01289 5.22513C6.16723 4.44921 6.54819 3.73648 7.1076 3.17707C7.66701 2.61766 8.37975 2.2367 9.15567 2.08235C9.93159 1.92801 10.7359 2.00723 11.4668 2.30998C12.1977 2.61273 12.8224 3.12542 13.2619 3.78321C13.7014 4.44101 13.936 5.21437 13.936 6.0055C13.936 7.06636 13.5146 8.08378 12.7645 8.83392C12.0143 9.58407 10.9969 10.0055 9.93603 10.0055Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const PersonIconFilled = ({
	className = '',
	width = '18',
	height = '19',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 18 19'
			fill='currentColor'
			aria-hidden
		>
			<path
				d='M8.97186 8.98182C11.484 8.98182 13.6372 6.90909 13.6372 4.49091C13.6372 2.07273 11.484 0 8.97186 0C6.45974 0 4.30649 2.07273 4.30649 4.49091C4.30649 6.90909 6.45974 8.98182 8.97186 8.98182ZM15.7905 13.6455C11.1251 10.0182 4.30649 10.7091 0.538311 15.2C0.179437 15.7182 0 16.2364 0 16.7545C0 17.9636 1.07662 19 2.33268 19H15.611C16.5082 19 17.4054 18.4818 17.7643 17.7909C18.1231 17.1 18.1231 16.0636 17.4054 15.3727C16.8671 14.6818 16.3288 14.1636 15.7905 13.6455Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const LocalizationIcon = ({
	className = '',
	width = '16',
	height = '20',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 16 20'
			fill='currentColor'
			aria-hidden
		>
			<path
				d='M8 -0.0100098C5.87827 -0.0100098 3.84344 0.832845 2.34315 2.33314C0.842855 3.83343 0 5.86826 0 7.98999C0 13.39 7.05 19.49 7.35 19.75C7.53113 19.9049 7.76165 19.9901 8 19.9901C8.23835 19.9901 8.46887 19.9049 8.65 19.75C9 19.49 16 13.39 16 7.98999C16 5.86826 15.1571 3.83343 13.6569 2.33314C12.1566 0.832845 10.1217 -0.0100098 8 -0.0100098ZM8 17.64C5.87 15.64 2 11.33 2 7.98999C2 6.39869 2.63214 4.87257 3.75736 3.74735C4.88258 2.62213 6.4087 1.98999 8 1.98999C9.5913 1.98999 11.1174 2.62213 12.2426 3.74735C13.3679 4.87257 14 6.39869 14 7.98999C14 11.33 10.13 15.65 8 17.64ZM8 3.98999C7.20887 3.98999 6.43552 4.22459 5.77772 4.66411C5.11992 5.10364 4.60723 5.72835 4.30448 6.45926C4.00173 7.19016 3.92252 7.99443 4.07686 8.77035C4.2312 9.54628 4.61216 10.259 5.17157 10.8184C5.73098 11.3778 6.44371 11.7588 7.21964 11.9131C7.99556 12.0675 8.79983 11.9883 9.53073 11.6855C10.2616 11.3828 10.8864 10.8701 11.3259 10.2123C11.7654 9.55447 12 8.78112 12 7.98999C12 6.92912 11.5786 5.91171 10.8284 5.16156C10.0783 4.41142 9.06087 3.98999 8 3.98999ZM8 9.98999C7.60444 9.98999 7.21776 9.87269 6.88886 9.65293C6.55996 9.43317 6.30362 9.12081 6.15224 8.75536C6.00087 8.3899 5.96126 7.98777 6.03843 7.59981C6.1156 7.21185 6.30608 6.85548 6.58579 6.57578C6.86549 6.29607 7.22186 6.10559 7.60982 6.02842C7.99778 5.95125 8.39991 5.99086 8.76537 6.14223C9.13082 6.29361 9.44318 6.54995 9.66294 6.87885C9.8827 7.20775 10 7.59443 10 7.98999C10 8.52042 9.78929 9.02913 9.41421 9.4042C9.03914 9.77928 8.53043 9.98999 8 9.98999Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const LocalizationIconFilled = ({
	className = '',
	width = '16',
	height = '20',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			width={width}
			height={height}
			viewBox='0 0 13 19'
			fill='currentColor'
			xmlns='http://www.w3.org/2000/svg'
			aria-hidden
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0 6.99732C0 3.13901 2.91595 0 6.49973 0C10.0837 0 12.9996 3.13901 13 6.99732C13 8.00372 12.8088 8.9646 12.4316 9.85351C10.8059 13.6821 7.69011 17.7236 6.77401 18.8708C6.70535 18.9566 6.60525 19.006 6.49991 19.006C6.39457 19.006 6.29447 18.9566 6.22581 18.8708C5.30935 17.7234 2.19356 13.6817 0.568446 9.85351C0.191349 8.9646 0 8.00372 0 6.99732ZM3.79158 6.70806C3.79158 8.24911 5.00661 9.50299 6.49991 9.50299C7.99337 9.50299 9.20839 8.24911 9.20825 6.70806C9.20825 5.16686 7.99322 3.91298 6.49991 3.91298C5.00661 3.91298 3.79158 5.16686 3.79158 6.70806Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const TagIcon = ({
	className = '',
	width = '20',
	height = '20',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			width={width}
			height={height}
			viewBox='0 0 20 20'
			fill='currentColor'
			xmlns='http://www.w3.org/2000/svg'
			aria-hidden
		>
			<path
				d='M5.00002 4.00002C4.80224 4.00002 4.6089 4.05867 4.44445 4.16855C4.28 4.27843 4.15182 4.43461 4.07614 4.61733C4.00045 4.80006 3.98065 5.00113 4.01923 5.19511C4.05782 5.38909 4.15306 5.56727 4.29291 5.70712C4.43276 5.84698 4.61095 5.94222 4.80493 5.9808C4.99891 6.01939 5.19997 5.99958 5.3827 5.9239C5.56543 5.84821 5.7216 5.72004 5.83149 5.55559C5.94137 5.39114 6.00002 5.1978 6.00002 5.00002C6.00002 4.7348 5.89466 4.48045 5.70712 4.29291C5.51959 4.10537 5.26523 4.00002 5.00002 4.00002ZM19.71 9.78002L10.23 0.320017C10.1368 0.21948 10.0239 0.139192 9.89828 0.0841425C9.7727 0.0290929 9.63713 0.000457809 9.50002 1.67143e-05H3.50002C3.36841 -0.000744179 3.23795 0.0244809 3.11611 0.0742455C2.99427 0.12401 2.88346 0.197335 2.79002 0.290017L0.290017 2.78002C0.197335 2.87346 0.12401 2.98427 0.0742455 3.10611C0.0244809 3.22795 -0.000744179 3.35841 1.67143e-05 3.49002V9.49002C0.0037002 9.75478 0.107283 10.0084 0.290017 10.2L9.78002 19.7C9.97165 19.8828 10.2253 19.9863 10.49 19.99C10.6216 19.9908 10.7521 19.9656 10.8739 19.9158C10.9958 19.866 11.1066 19.7927 11.2 19.7L19.71 11.19C19.8027 11.0966 19.876 10.9858 19.9258 10.8639C19.9756 10.7421 20.0008 10.6116 20 10.48C19.9938 10.2187 19.8904 9.96912 19.71 9.78002ZM10.49 17.59L2.00002 9.09002V3.90002L3.90002 2.00002H9.08002L17.58 10.49L10.49 17.59Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const TagIconFilled = ({
	className = '',
	width = '15',
	height = '15',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 15 15`}
			fill='currentColor'
			aria-hidden
		>
			<path
				d='M3.5 2.07025C3.20333 2.07025 2.91332 2.15823 2.66664 2.32305C2.41997 2.48787 2.22771 2.72214 2.11418 2.99623C2.00065 3.27032 1.97094 3.57192 2.02882 3.86289C2.0867 4.15386 2.22956 4.42113 2.43934 4.63091C2.64912 4.84069 2.91639 4.98355 3.20736 5.04143C3.49834 5.09931 3.79994 5.0696 4.07403 4.95607C4.34811 4.84254 4.58238 4.65028 4.7472 4.40361C4.91203 4.15693 5 3.86692 5 3.57025C5 3.17243 4.84196 2.7909 4.56066 2.50959C4.27936 2.22829 3.89782 2.07025 3.5 2.07025ZM15.71 9.60025L9.53 15.7703C9.34264 15.9565 9.08919 16.061 8.825 16.061C8.56081 16.061 8.30736 15.9565 8.12 15.7703L0.293329 7.95322C0.105526 7.76565 0 7.51111 0 7.24568V1.07025C0 0.517967 0.447715 0.0702515 1 0.0702515H7.17579C7.441 0.0702515 7.69536 0.175608 7.88289 0.363145L15.71 8.19025C15.8027 8.28369 15.876 8.39451 15.9258 8.51635C15.9755 8.63818 16.0008 8.76865 16 8.90025C15.9989 9.16259 15.8947 9.41399 15.71 9.60025Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const DateIcon = ({
	className = '',
	width = '20',
	height = '20',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 20 20'
			fill='currentColor'
			aria-hidden
		>
			<path
				d='M17 2H15V1C15 0.734784 14.8946 0.48043 14.7071 0.292893C14.5196 0.105357 14.2652 0 14 0C13.7348 0 13.4804 0.105357 13.2929 0.292893C13.1054 0.48043 13 0.734784 13 1V2H7V1C7 0.734784 6.89464 0.48043 6.70711 0.292893C6.51957 0.105357 6.26522 0 6 0C5.73478 0 5.48043 0.105357 5.29289 0.292893C5.10536 0.48043 5 0.734784 5 1V2H3C2.20435 2 1.44129 2.31607 0.87868 2.87868C0.316071 3.44129 0 4.20435 0 5V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H17C17.7956 20 18.5587 19.6839 19.1213 19.1213C19.6839 18.5587 20 17.7956 20 17V5C20 4.20435 19.6839 3.44129 19.1213 2.87868C18.5587 2.31607 17.7956 2 17 2ZM18 17C18 17.2652 17.8946 17.5196 17.7071 17.7071C17.5196 17.8946 17.2652 18 17 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V10H18V17ZM18 8H2V5C2 4.73478 2.10536 4.48043 2.29289 4.29289C2.48043 4.10536 2.73478 4 3 4H5V5C5 5.26522 5.10536 5.51957 5.29289 5.70711C5.48043 5.89464 5.73478 6 6 6C6.26522 6 6.51957 5.89464 6.70711 5.70711C6.89464 5.51957 7 5.26522 7 5V4H13V5C13 5.26522 13.1054 5.51957 13.2929 5.70711C13.4804 5.89464 13.7348 6 14 6C14.2652 6 14.5196 5.89464 14.7071 5.70711C14.8946 5.51957 15 5.26522 15 5V4H17C17.2652 4 17.5196 4.10536 17.7071 4.29289C17.8946 4.48043 18 4.73478 18 5V8Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const DateIconFilled = ({
	className = '',
	width = '20',
	height = '20',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 20 20'
			fill='currentColor'
			aria-hidden
		>
			<path
				d='M0 17C0 18.7 1.3 20 3 20H17C18.7 20 20 18.7 20 17V9H0V17ZM17 2H15V1C15 0.4 14.6 0 14 0C13.4 0 13 0.4 13 1V2H7V1C7 0.4 6.6 0 6 0C5.4 0 5 0.4 5 1V2H3C1.3 2 0 3.3 0 5V7H20V5C20 3.3 18.7 2 17 2Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const PriceIcon = ({
	className = '',
	width = '20',
	height = '15',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 20 15'
			fill='currentColor'
			aria-hidden
		>
			<path
				d='M7 5.48999C6.73478 5.48999 6.48043 5.59535 6.29289 5.78288C6.10536 5.97042 6 6.22477 6 6.48999V8.48999C6 8.75521 6.10536 9.00956 6.29289 9.1971C6.48043 9.38463 6.73478 9.48999 7 9.48999C7.26522 9.48999 7.51957 9.38463 7.70711 9.1971C7.89464 9.00956 8 8.75521 8 8.48999V6.48999C8 6.22477 7.89464 5.97042 7.70711 5.78288C7.51957 5.59535 7.26522 5.48999 7 5.48999ZM19 6.48999C19.2652 6.48999 19.5196 6.38463 19.7071 6.1971C19.8946 6.00956 20 5.75521 20 5.48999V1.48999C20 1.22477 19.8946 0.97042 19.7071 0.782884C19.5196 0.595347 19.2652 0.48999 19 0.48999H1C0.734784 0.48999 0.48043 0.595347 0.292893 0.782884C0.105357 0.97042 0 1.22477 0 1.48999V5.48999C0 5.75521 0.105357 6.00956 0.292893 6.1971C0.48043 6.38463 0.734784 6.48999 1 6.48999C1.26522 6.48999 1.51957 6.59535 1.70711 6.78288C1.89464 6.97042 2 7.22477 2 7.48999C2 7.75521 1.89464 8.00956 1.70711 8.1971C1.51957 8.38463 1.26522 8.48999 1 8.48999C0.734784 8.48999 0.48043 8.59535 0.292893 8.78288C0.105357 8.97042 0 9.22477 0 9.48999V13.49C0 13.7552 0.105357 14.0096 0.292893 14.1971C0.48043 14.3846 0.734784 14.49 1 14.49H19C19.2652 14.49 19.5196 14.3846 19.7071 14.1971C19.8946 14.0096 20 13.7552 20 13.49V9.48999C20 9.22477 19.8946 8.97042 19.7071 8.78288C19.5196 8.59535 19.2652 8.48999 19 8.48999C18.7348 8.48999 18.4804 8.38463 18.2929 8.1971C18.1054 8.00956 18 7.75521 18 7.48999C18 7.22477 18.1054 6.97042 18.2929 6.78288C18.4804 6.59535 18.7348 6.48999 19 6.48999ZM18 4.66999C17.4208 4.88019 16.9205 5.26362 16.5668 5.76816C16.2132 6.27269 16.0235 6.87387 16.0235 7.48999C16.0235 8.10611 16.2132 8.70729 16.5668 9.21183C16.9205 9.71636 17.4208 10.0998 18 10.31V12.49H8C8 12.2248 7.89464 11.9704 7.70711 11.7829C7.51957 11.5953 7.26522 11.49 7 11.49C6.73478 11.49 6.48043 11.5953 6.29289 11.7829C6.10536 11.9704 6 12.2248 6 12.49H2V10.31C2.57915 10.0998 3.07954 9.71636 3.43316 9.21183C3.78678 8.70729 3.97648 8.10611 3.97648 7.48999C3.97648 6.87387 3.78678 6.27269 3.43316 5.76816C3.07954 5.26362 2.57915 4.88019 2 4.66999V2.48999H6C6 2.75521 6.10536 3.00956 6.29289 3.1971C6.48043 3.38463 6.73478 3.48999 7 3.48999C7.26522 3.48999 7.51957 3.38463 7.70711 3.1971C7.89464 3.00956 8 2.75521 8 2.48999H18V4.66999Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const PriceIconFilled = ({
	className = '',
	width = '16',
	height = '11',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			width={width}
			height={height}
			viewBox='0 0 16 11'
			fill='currentColor'
			xmlns='http://www.w3.org/2000/svg'
			aria-hidden
		>
			<path
				d='M5 3.5C4.73478 3.5 4.48043 3.60536 4.29289 3.79289C4.10536 3.98043 4 4.23478 4 4.5V6.5C4 6.76522 4.10536 7.01957 4.29289 7.20711C4.48043 7.39464 4.73478 7.5 5 7.5C5.26522 7.5 5.51957 7.39464 5.70711 7.20711C5.89464 7.01957 6 6.76522 6 6.5V4.5C6 4.23478 5.89464 3.98043 5.70711 3.79289C5.51957 3.60536 5.26522 3.5 5 3.5ZM16 2.68C15.4208 2.8902 14.9205 3.27363 14.5668 3.77816C14.2132 4.2827 14.0235 4.88388 14.0235 5.5C14.0235 6.11612 14.2132 6.7173 14.5668 7.22184C14.9205 7.72637 15.4208 8.1098 16 8.32V10.5H6C6 10.2348 5.89464 9.98043 5.70711 9.79289C5.51957 9.60536 5.26522 9.5 5 9.5C4.73478 9.5 4.48043 9.60536 4.29289 9.79289C4.10536 9.98043 4 10.2348 4 10.5H0V8.32C0.579152 8.1098 1.07954 7.72637 1.43316 7.22184C1.78678 6.7173 1.97648 6.11612 1.97648 5.5C1.97648 4.88388 1.78678 4.2827 1.43316 3.77816C1.07954 3.27363 0.579152 2.8902 0 2.68V0.5H4C4 0.765216 4.10536 1.01957 4.29289 1.20711C4.48043 1.39464 4.73478 1.5 5 1.5C5.26522 1.5 5.51957 1.39464 5.70711 1.20711C5.89464 1.01957 6 0.765216 6 0.5H16V2.68Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const FilledIconType = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<path
				d='M30.55 13C35.305 13 38.5 17.47 38.5 21.64C38.5 30.085 25.24 37 25 37C24.76 37 11.5 30.085 11.5 21.64C11.5 17.47 14.695 13 19.45 13C22.18 13 23.965 14.365 25 15.565C26.035 14.365 27.82 13 30.55 13Z'
				fill='#1B30F5'
				stroke='#1B30F5'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const OutlinedIconType = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<path
				d='M30.55 13C35.305 13 38.5 17.47 38.5 21.64C38.5 30.085 25.24 37 25 37C24.76 37 11.5 30.085 11.5 21.64C11.5 17.47 14.695 13 19.45 13C22.18 13 23.965 14.365 25 15.565C26.035 14.365 27.82 13 30.55 13Z'
				stroke='#1B30F5'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const SiteIcon = ({
	className = '',
	width = '20',
	height = '15',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			width={width}
			height={height}
			viewBox='0 0 20 20'
			fill='currentColor'
			xmlns='http://www.w3.org/2000/svg'
			aria-hidden
		>
			<path
				d='M19.3702 6.6223C19.3702 6.6223 19.3702 6.6223 19.3702 6.5723C18.6656 4.64853 17.3871 2.98759 15.7076 1.81417C14.0282 0.640746 12.0289 0.0114746 9.98016 0.0114746C7.93141 0.0114746 5.93209 0.640746 4.25267 1.81417C2.57324 2.98759 1.29476 4.64853 0.590156 6.5723C0.590156 6.5723 0.590156 6.5723 0.590156 6.6223C-0.196719 8.7932 -0.196719 11.1714 0.590156 13.3423C0.590156 13.3423 0.590156 13.3423 0.590156 13.3923C1.29476 15.3161 2.57324 16.977 4.25267 18.1504C5.93209 19.3239 7.93141 19.9531 9.98016 19.9531C12.0289 19.9531 14.0282 19.3239 15.7076 18.1504C17.3871 16.977 18.6656 15.3161 19.3702 13.3923C19.3702 13.3923 19.3702 13.3923 19.3702 13.3423C20.157 11.1714 20.157 8.7932 19.3702 6.6223ZM2.22016 11.9823C1.87338 10.6715 1.87338 9.29309 2.22016 7.9823H4.08016C3.92019 9.31084 3.92019 10.6538 4.08016 11.9823H2.22016ZM3.04016 13.9823H4.44016C4.67488 14.8741 5.01037 15.7364 5.44016 16.5523C4.45945 15.8842 3.63965 15.0064 3.04016 13.9823ZM4.44016 5.9823H3.04016C3.63103 4.96139 4.44035 4.08377 5.41016 3.4123C4.99071 4.22955 4.6653 5.09172 4.44016 5.9823ZM8.96016 17.6823C7.73192 16.781 6.8693 15.4675 6.53016 13.9823H8.96016V17.6823ZM8.96016 11.9823H6.10016C5.91355 10.6555 5.91355 9.30911 6.10016 7.9823H8.96016V11.9823ZM8.96016 5.9823H6.53016C6.8693 4.49707 7.73192 3.18362 8.96016 2.2823V5.9823ZM16.8802 5.9823H15.4802C15.2454 5.09046 14.9099 4.22824 14.4802 3.4123C15.4609 4.08037 16.2807 4.95824 16.8802 5.9823ZM10.9602 2.2823C12.1884 3.18362 13.051 4.49707 13.3902 5.9823H10.9602V2.2823ZM10.9602 17.6823V13.9823H13.3902C13.051 15.4675 12.1884 16.781 10.9602 17.6823ZM13.8202 11.9823H10.9602V7.9823H13.8202C14.0068 9.30911 14.0068 10.6555 13.8202 11.9823ZM14.5102 16.5523C14.9399 15.7364 15.2754 14.8741 15.5102 13.9823H16.9102C16.3107 15.0064 15.4909 15.8842 14.5102 16.5523ZM17.7002 11.9823H15.8402C15.9215 11.3188 15.9616 10.6508 15.9602 9.9823C15.9613 9.31381 15.9212 8.64587 15.8402 7.9823H17.7002C18.0469 9.29309 18.0469 10.6715 17.7002 11.9823Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const SiteIconFilled = ({
	className = '',
	width = '16',
	height = '16',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			width={width}
			height={height}
			viewBox='0 0 20 20'
			fill='currentColor'
			xmlns='http://www.w3.org/2000/svg'
			aria-hidden
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M3 9.78019C3 9.08152 3.05902 8.4148 3.16654 7.78022H0.200036C0.0688605 8.42644 0 9.09529 0 9.78022C0 10.4652 0.0688605 11.134 0.200036 11.7802H3.16655C3.05902 11.1456 3 10.4789 3 9.78019ZM0.832087 13.7802C2.10482 16.6932 4.72518 18.8826 7.90511 19.5604C6.41738 18.3661 4.64592 16.4325 3.69161 13.7802H0.832087ZM12.095 19.5604C15.2749 18.8826 17.8952 16.6932 19.1679 13.7802H16.3084C15.3541 16.4324 13.5827 18.366 12.095 19.5604ZM19.8 11.7802C19.9311 11.134 20 10.4652 20 9.78022C20 9.09529 19.9311 8.42644 19.8 7.78022H16.8335C16.941 8.41482 17 9.08157 17 9.78025C17 10.4789 16.941 11.1456 16.8335 11.7802H19.8ZM19.1679 5.78022C17.8952 2.86725 15.2748 0.677829 12.0949 0C13.5826 1.19437 15.3541 3.12797 16.3084 5.78022H19.1679ZM7.905 2.41573e-05C4.72511 0.677881 2.1048 2.86729 0.832087 5.78022H3.69158C4.64587 3.12801 6.41728 1.19441 7.905 2.41573e-05ZM15 9.78025C15 10.4846 14.9269 11.1515 14.7964 11.7802H11V7.78022H14.7963C14.9268 8.40895 15 9.07586 15 9.78025ZM9 7.78022V11.7802H5.20365C5.07316 11.1515 5 10.4846 5 9.78019C5 9.07582 5.07315 8.40893 5.20364 7.78022H9ZM9 13.7802H5.84996C6.65671 15.5928 7.90524 16.9671 9 17.8763V13.7802ZM14.1501 13.7802H11V17.8764C12.0948 16.9672 13.3433 15.5928 14.1501 13.7802ZM14.15 5.78022C13.3433 3.96763 12.0948 2.5933 11 1.68415V5.78022H14.15ZM9 5.78022H5.84993C6.65667 3.9676 7.90523 2.59324 9 1.68408V5.78022Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const ArrowSmall = ({
	className = '',
	width = '22',
	height = '18',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 22 18'
			fill='none'
			aria-hidden
		>
			<path d='M12.4854 1L20.4854 9L12.4854 17' stroke='currentColor' />
			<path d='M20 9H0' stroke='currentColor' />
		</svg>
	);
};

export const ArrowBold = ({
	className = '',
	width = '20',
	height = '14',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			aria-hidden='true'
			width={width}
			height={height}
			className={className}
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path d='M18 7L0 7' stroke='currentColor' strokeWidth='2' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M19.1926 7.70711L19.8997 7L19.1926 6.29289L12.8997 0H10.0713L17.0713 7L10.0713 14H12.8997L19.1926 7.70711Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const ArrowFull = ({
	className = '',
	width = '21',
	height = '15',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			aria-hidden='true'
			width={width}
			height={height}
			className={className}
			viewBox='0 0 21 15'
			fill='currentColor'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M20.1318 6.94034C20.3271 7.13561 20.3271 7.45219 20.1318 7.64745L13.3389 14.4403C13.0239 14.7553 12.4854 14.5322 12.4854 14.0868V8.7939H0.5C0.223858 8.7939 0 8.57004 0 8.29389V6.2939C0 6.01775 0.223858 5.7939 0.5 5.7939H12.4854V0.501002C12.4854 0.0555499 13.0239 -0.167533 13.3389 0.147449L20.1318 6.94034Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const ArrowLong = ({
	className = '',
	width = '15',
}: {
	className?: string;
	width?: string;
}) => {
	return (
		<svg
			width={width}
			height='10'
			viewBox='0 0 26 10'
			fill='currentColor'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			aria-hidden='true'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M21.1779 4.59891L18.6536 2.05696L19.718 1L24.0367 5.34889L19.718 9.69777L18.6536 8.64081L21.1779 6.09891L2.00002 6.09915L2 4.59915L21.1779 4.59891Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const ValidationIcon = ({
	className = '',
	width = '46',
	height = '46',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 46 47'
			fill='none'
			aria-hidden='true'
		>
			<path
				d='M23 46.9487C10.3174 46.9487 0 36.6309 0 23.9487C0 11.2666 10.3174 0.94873 23 0.94873C35.6826 0.94873 46 11.2666 46 23.9487C46 36.6309 35.6826 46.9487 23 46.9487Z'
				fill='currentColor'
			/>
			<path
				d='M18.8281 34.606L8 23.7773L10.8281 20.9487L18.8281 28.9487L34.8281 12.9487L37.6562 15.7773L18.8281 34.606Z'
				fill='white'
			/>
		</svg>
	);
};

export const ErrorIcon = ({
	className = '',
	width = '12',
	height = '13',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			pointerEvents='visibilePainted'
			className={className}
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox='0 0 12 13'
			fill='none'
			aria-hidden='true'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0 6.25635C0 9.56486 2.69149 12.2563 6 12.2563C9.30851 12.2563 12 9.56486 12 6.25635C12 2.94784 9.30851 0.256348 6 0.256348C2.69149 0.256348 0 2.94784 0 6.25635ZM7.04348 6.25634L8.86956 8.08243L7.82608 9.12591L6 7.29982L4.17391 9.12591L3.13043 8.08243L4.95652 6.25634L3.13043 4.43026L4.17391 3.38678L6 5.21287L7.82608 3.38678L8.86956 4.43026L7.04348 6.25634Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const BurgerIcon = ({
	className = '',
	width = '50',
	height = '22',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			className={className}
			width={width}
			height={height}
			viewBox='0 0 50 22'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			aria-hidden='true'
		>
			<line x1='1' y1='1' x2='49' y2='1' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
			<line
				x1='1'
				y1='11'
				x2='49'
				y2='11'
				stroke='currentColor'
				strokeWidth='2'
				strokeLinecap='round'
			/>
			<line
				x1='1'
				y1='21'
				x2='49'
				y2='21'
				stroke='currentColor'
				strokeWidth='2'
				strokeLinecap='round'
			/>
		</svg>
	);
};

export const BurgerSmallIcon = ({
	className = '',
	width = '24',
	height = '24',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			aria-hidden='true'
		>
			<path d='M5 14L15 14' stroke='currentColor' strokeWidth='2' strokeLinecap='square' />
			<path d='M5 6L15 6' stroke='currentColor' strokeWidth='2' strokeLinecap='square' />
			<path d='M5 10L15 10' stroke='currentColor' strokeWidth='2' strokeLinecap='square' />
		</svg>
	);
};

export const BurgerLightIcon = ({
	className = '',
	width = '26',
	height = '26',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			aria-hidden='true'
		>
			<path d='M20 17H0' stroke='currentColor' />
			<path d='M17 10H3' stroke='currentColor' />
			<path d='M20 3H0' stroke='currentColor' />
		</svg>
	);
};

export const BurgerRoundIcon = ({
	className = '',
	width = '22',
	height = '20',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 22 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			aria-hidden='true'
		>
			<path d='M21 18L1.5 18' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
			<path d='M21 2L1.5 2' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
			<path d='M21 10L1.5 10' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
		</svg>
	);
};

export const BurgerCloseIcon = ({
	className = '',
	width = '46',
	height = '27',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 46 27'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			aria-hidden='true'
		>
			<line
				x1='2.71563'
				y1='1.13397'
				x2='44.2849'
				y2='25.134'
				stroke='currentColor'
				strokeWidth='2'
				strokeLinecap='round'
			/>
			<line
				x1='1.71563'
				y1='25.134'
				x2='43.2849'
				y2='1.13397'
				stroke='currentColor'
				strokeWidth='2'
				strokeLinecap='round'
			/>
		</svg>
	);
};

export const CloseIcon = ({
	className = '',
	width = '20',
	height = '20',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 21 21'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			aria-hidden='true'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.8618 8.81113L2.55069 0.5L0.86183 2.18886L9.17296 10.5L0.861816 18.8111L2.55068 20.5L10.8618 12.1889L18.8763 20.2034L20.5652 18.5145L12.5507 10.5L20.5652 2.48549L18.8763 0.796628L10.8618 8.81113Z'
				fill='currentColor'
			/>
		</svg>
	);
};

//search Icons
export const SearchLightIcon = ({
	className = '',
	width = '22',
	height = '22',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 22 22'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			aria-hidden='true'
		>
			<circle cx='8.31707' cy='8.31707' r='7.31707' stroke='currentColor' />
			<path
				d='M20.6465 21.3536C20.8417 21.5488 21.1583 21.5488 21.3536 21.3536C21.5488 21.1583 21.5488 20.8417 21.3536 20.6465L20.6465 21.3536ZM21.3536 20.6465L13.5487 12.8416L12.8416 13.5487L20.6465 21.3536L21.3536 20.6465Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const SearchBigIcon = ({
	className = '',
	width = '22',
	height = '22',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			aria-hidden='true'
			className={className}
			width={width}
			height={height}
			viewBox='0 0 22 22'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M16.1765 16.1721L21 21M18.7778 9.88889C18.7778 14.7981 14.7981 18.7778 9.88889 18.7778C4.97969 18.7778 1 14.7981 1 9.88889C1 4.97969 4.97969 1 9.88889 1C14.7981 1 18.7778 4.97969 18.7778 9.88889Z'
				stroke='currentColor'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const SearchSmallIcon = ({
	className = '',
	width = '21',
	height = '21',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			aria-hidden='true'
			className={className}
			width={width}
			height={height}
			viewBox='0 0 21 21'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<ellipse
				cx='7.66667'
				cy='7.66667'
				rx='6.66667'
				ry='6.66667'
				stroke='currentColor'
				strokeWidth='2'
			/>
			<path d='M17.8889 17.8889L13 13' stroke='currentColor' strokeWidth='2' strokeLinecap='square' />
		</svg>
	);
};

export const CloseSmallIcon = ({
	className = '',
	width = '20',
	height = '20',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			aria-hidden='true'
			className={className}
			width={width}
			height={height}
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path d='M15 15L5 5' stroke='currentColor' strokeWidth='2' strokeLinecap='square' />
			<path d='M5 15L15 5' stroke='currentColor' strokeWidth='2' strokeLinecap='square' />
		</svg>
	);
};

export const CloseLightIcon = ({
	className = '',
	width = '22',
	height = '22',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			aria-hidden='true'
			className={className}
			width={width}
			height={height}
			viewBox='0 0 22 22'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path d='M21 21L1 1' stroke='currentColor' />
			<path d='M0.999999 21L21 1' stroke='currentColor' />
		</svg>
	);
};

export const CloseRoundIcon = ({
	className = '',
	width = '20',
	height = '20',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			aria-hidden='true'
			className={className}
			width={width}
			height={height}
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path d='M19 19L1 1' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
			<path d='M0.999999 19L19 1' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
		</svg>
	);
};
// Menu Caret
export const MenuChildCaretSmall = ({
	className = '',
	width = '14',
	height = '9',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 14 9'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			aria-hidden='true'
		>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M6.99992 8.32819L0.292819 1.62108L1.70703 0.206865L6.99992 5.49976L12.2928 0.206866L13.707 1.62108L6.99992 8.32819Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const MenuChildCaretFull = ({
	className = '',
	width = '15',
	height = '15',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			className={className}
			width={width}
			height={height}
			viewBox='0 0 15 15'
			fill='currentColor'
			xmlns='http://www.w3.org/2000/svg'
			aria-hidden='true'
		>
			<path
				d='M6.64645 10.6464L1.85355 5.85355C1.53857 5.53857 1.76165 5 2.20711 5H11.7929C12.2383 5 12.4614 5.53857 12.1464 5.85355L7.35355 10.6464C7.15829 10.8417 6.84171 10.8417 6.64645 10.6464Z'
				fill='currentColor'
			/>
		</svg>
	);
};

export const MenuChildCaretLight = ({
	className = '',
	width = '15',
	height = '15',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			className={className}
			width={width}
			height={height}
			viewBox='0 0 15 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			aria-hidden='true'
		>
			<path
				d='M1 5L7.5 11.5L14 5'
				stroke='currentColor'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const MenuChildCaretBig = ({
	className = '',
	width = '17',
	height = '15',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			className={className}
			width={width}
			aria-hidden='true'
			height={height}
			viewBox='0 0 17 15'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M1 4L8.5 11.5L16 4'
				stroke='currentColor'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const Wave = ({
	className = '',
	pathClassName = '',
}: {
	className?: string;
	pathClassName?: string;
}) => {
	return (
		<svg
			data-svg='wave'
			aria-hidden
			className={`${className}`}
			height='76'
			viewBox='0 0 1680 76'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			preserveAspectRatio='none'
		>
			<path
				d='M1680 33.2759V76H2.41822e-05C-3.01547e-05 3.78696 2.41936e-05 33.2759 2.41936e-05 33.2759C2.41936e-05 33.2759 74.9995 63.3647 187.999 63.3647C300.999 63.3647 318 33.2759 420 33.2759C522 33.2759 534.999 63.3647 630 63.3647C725.001 63.3647 736.501 13.7183 840 1.38188C943.499 -10.9545 968 63.3647 1050 63.3647C1132 63.3647 1145.5 33.2759 1260 33.2759C1374.5 33.2759 1378.5 55.5415 1470 63.3647C1561.5 71.1878 1680 33.2759 1680 33.2759Z'
				className={pathClassName}
			/>
		</svg>
	);
};

export const Bubble = ({
	className = '',
	pathClassName = '',
	position = 'left',
}: {
	className?: string;
	pathClassName?: string;
	position?: 'left' | 'right';
}) => {
	return (
		<svg
			data-svg={`circle-${position}`}
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 150 300'
			preserveAspectRatio='none'
			className={`${className} pointer-events-none`}
			aria-hidden='true'
		>
			<g id='Calque_2' data-name='Calque 2'>
				<g id='Calque_1-2' data-name='Calque 1'>
					<path
						className={pathClassName}
						d='M118,148.45A148.86,148.86,0,0,1,.5,294V3A148.86,148.86,0,0,1,118,148.45Z'
					/>
					<rect fill='none' x='0.5' width='23' height='150' />
				</g>
			</g>
		</svg>
	);
};

export const ColorsDashboardIcon = ({
	className = '',
	width = '30',
	height = '30',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			aria-hidden='true'
		>
			<rect y='0.000488281' width='30' height='30' rx='4' fill='#D9E2FF' />
			<path
				d='M11.4444 23.0005H20.1556C21.1512 23.0005 21.649 23.0005 22.0293 22.8067C22.3638 22.6363 22.6358 22.3643 22.8062 22.0298C23 21.6495 23 21.1517 23 20.156V18.7338C23 17.7382 23 17.2403 22.8062 16.8601C22.6358 16.5256 22.3638 16.2536 22.0293 16.0831C21.649 15.8894 21.1512 15.8894 20.1556 15.8894H20.0283M14.1111 11.7499L16.1314 9.7297C16.8354 9.02567 17.1874 8.67365 17.5933 8.54176C17.9504 8.42575 18.335 8.42575 18.6921 8.54176C19.098 8.67365 19.45 9.02567 20.154 9.7297L21.1597 10.7354C21.8637 11.4394 22.2157 11.7914 22.3476 12.1973C22.4636 12.5544 22.4636 12.939 22.3476 13.296C22.2157 13.702 21.8637 14.054 21.1597 14.758L20.0283 15.8894M14.1111 11.7499V9.84493C14.1111 8.84928 14.1111 8.35146 13.9173 7.97117C13.7469 7.63666 13.4749 7.3647 13.1404 7.19425C12.7601 7.00049 12.2623 7.00049 11.2667 7.00049H9.84444C8.8488 7.00049 8.35097 7.00049 7.97068 7.19425C7.63617 7.3647 7.36421 7.63666 7.19377 7.97117C7 8.35146 7 8.84928 7 9.84493V20.156C7 21.1517 7 21.6495 7.19377 22.0298C7.36421 22.3643 7.63617 22.6363 7.97068 22.8067C8.35097 23.0005 8.8488 23.0005 9.84444 23.0005H11.2667C12.2623 23.0005 12.7601 23.0005 13.1404 22.8067C13.4749 22.6363 13.7469 22.3643 13.9173 22.0298C13.9268 22.0113 13.9357 21.9925 13.9443 21.9734M14.1111 11.7499V20.156C14.1111 21.1032 14.1111 21.5999 13.9443 21.9734M20.0283 15.8894L13.9443 21.9734M10.5556 19.4449H10.5644'
				stroke='#3A5AFF'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const FontsDashboardIcon = ({
	className = '',
	width = '30',
	height = '30',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
			aria-hidden='true'
		>
			<rect y='0.000488281' width='30' height='30' rx='4' fill='white' />
			<path
				d='M11.4444 8.77832V21.2228M11.4444 21.2228H9.66667M11.4444 21.2228H13.2222M19.4444 15.0005V21.2228M19.4444 15.0005H15.8889V16.7783M19.4444 15.0005H23V16.7783M19.4444 21.2228H17.6667M19.4444 21.2228H21.2222M15.8889 11.445V8.77832H7V11.445'
				stroke='#3A5AFF'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const BlocksDashboardIcon = ({
	className = '',
	width = '30',
	height = '30',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='none'
			className={className}
			aria-hidden='true'
		>
			<rect y='0.000488281' width='30' height='30' rx='4' fill='white' />
			<path
				d='M15 13.4064L7.07551 10.5166M15 13.4064L22.927 10.5262M15 13.4064V23.0005M8.89776 20.9264L14.0533 22.7708C14.4041 22.8963 14.5796 22.959 14.7595 22.9839C14.9191 23.006 15.0809 23.006 15.2405 22.9839C15.4204 22.959 15.5959 22.8963 15.9467 22.7708L21.1022 20.9264C21.7855 20.6819 22.1272 20.5597 22.3793 20.3405C22.6021 20.147 22.7741 19.9005 22.88 19.6232C23 19.3092 23 18.942 23 18.2076V11.7934C23 11.059 23 10.6917 22.88 10.3778C22.7741 10.1004 22.6021 9.85399 22.3793 9.66043C22.1272 9.44127 21.7855 9.31905 21.1022 9.07461L15.9467 7.23022C15.5959 7.10472 15.4204 7.04196 15.2405 7.01706C15.0809 6.99496 14.9191 6.99496 14.7595 7.01706C14.5796 7.04196 14.4041 7.10471 14.0533 7.23022L8.89776 9.07461C8.21448 9.31905 7.87285 9.44127 7.62066 9.66043C7.39792 9.85399 7.2259 10.1004 7.11995 10.3778C7 10.6917 7 11.059 7 11.7934V18.2076C7 18.942 7 19.3092 7.11995 19.6232C7.2259 19.9005 7.39792 20.147 7.62066 20.3405C7.87285 20.5597 8.21448 20.6819 8.89776 20.9264Z'
				stroke='#3A5AFF'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const HeaderDashboardIcon = ({
	className = '',
	width = '30',
	height = '30',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='none'
			className={className}
			aria-hidden='true'
		>
			<rect y='0.000488281' width='30' height='30' rx='4' fill='white' />
			<path
				d='M7 17.6672H23M7 21.2228H15.8889M8.42222 14.1117H21.5778C22.0756 14.1117 22.3245 14.1117 22.5147 14.0148C22.6819 13.9295 22.8179 13.7936 22.9031 13.6263C23 13.4362 23 13.1873 23 12.6894V10.2005C23 9.70272 23 9.45381 22.9031 9.26366C22.8179 9.09641 22.6819 8.96042 22.5147 8.8752C22.3245 8.77832 22.0756 8.77832 21.5778 8.77832H8.42222C7.9244 8.77832 7.67549 8.77832 7.48534 8.8752C7.31809 8.96042 7.1821 9.09641 7.09688 9.26366C7 9.45381 7 9.70272 7 10.2005V12.6894C7 13.1873 7 13.4362 7.09688 13.6263C7.1821 13.7936 7.31809 13.9295 7.48534 14.0148C7.67549 14.1117 7.9244 14.1117 8.42222 14.1117Z'
				stroke='#3A5AFF'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const LayoutDashboardIcon = ({
	className = '',
	width = '30',
	height = '30',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='none'
			className={className}
			aria-hidden='true'
		>
			<rect y='0.000488281' width='30' height='30' rx='4' fill='white' />
			<path
				d='M8 19V23M9 7V11M10 21H6M11 9H7M16 7L17.7528 11.4444C17.9407 11.9208 18.0347 12.1591 18.1786 12.3599C18.3061 12.538 18.462 12.6939 18.6401 12.8214C18.8409 12.9653 19.0792 13.0593 19.5556 13.2472L24 15L19.5556 16.7528C19.0792 16.9407 18.8409 17.0347 18.6401 17.1786C18.462 17.3061 18.3061 17.462 18.1786 17.6401C18.0347 17.8409 17.9407 18.0792 17.7528 18.5556L16 23L14.2472 18.5556C14.0593 18.0792 13.9653 17.8409 13.8214 17.6401C13.6939 17.462 13.538 17.3061 13.3599 17.1786C13.1591 17.0347 12.9208 16.9407 12.4444 16.7528L8 15L12.4444 13.2472C12.9208 13.0593 13.1591 12.9653 13.3599 12.8214C13.538 12.6939 13.6939 12.538 13.8214 12.3599C13.9653 12.1591 14.0593 11.9208 14.2472 11.4444L16 7Z'
				stroke='#3A5AFF'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const FooterDashboardIcon = ({
	className = '',
	width = '30',
	height = '30',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='none'
			className={className}
			aria-hidden='true'
		>
			<rect y='0.000488281' width='30' height='30' rx='4' fill='white' />
			<path
				d='M7 8.77832H23M7 12.3339H15.8889M8.42222 21.2228H21.5778C22.0756 21.2228 22.3245 21.2228 22.5147 21.1259C22.6819 21.0407 22.8179 20.9047 22.9031 20.7374C23 20.5473 23 20.2984 23 19.8005V17.3117C23 16.8138 23 16.5649 22.9031 16.3748C22.8179 16.2075 22.6819 16.0715 22.5147 15.9863C22.3245 15.8894 22.0756 15.8894 21.5778 15.8894H8.42222C7.9244 15.8894 7.67549 15.8894 7.48534 15.9863C7.31809 16.0715 7.1821 16.2075 7.09688 16.3748C7 16.5649 7 16.8138 7 17.3117V19.8005C7 20.2984 7 20.5473 7.09688 20.7374C7.1821 20.9047 7.31809 21.0407 7.48534 21.1259C7.67549 21.2228 7.9244 21.2228 8.42222 21.2228Z'
				stroke='#3A5AFF'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const HistoryDashboardIcon = ({
	className = '',
	width = '30',
	height = '30',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width={width}
			height={height}
			viewBox={`0 0 ${width} ${height}`}
			fill='none'
			className={className}
			aria-hidden='true'
		>
			<rect y='0.000488281' width='30' height='30' rx='4' fill='white' />
			<path
				d='M21.0002 7.00024V23.0002M11.8571 7.00024L7.28564 23.0002M16.4285 7.00024L14.1428 23.0002'
				stroke='#3A5AFF'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const NestedListIcon = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 16 16'
			fill='currentColor'
			className='size-4'
		>
			<path
				fillRule='evenodd'
				d='M6.22 4.22a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06l-3.25 3.25a.75.75 0 0 1-1.06-1.06L8.94 8 6.22 5.28a.75.75 0 0 1 0-1.06Z'
				clipRule='evenodd'
			/>
		</svg>
	);
};

export const OpenNewTabIcon = ({
	className = '',
	width = '14',
	height = '14',
}: {
	className?: string;
	width?: string;
	height?: string;
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 14 14'
			fill='currentColor'
			xmlns='http://www.w3.org/2000/svg'
			aria-hidden='true'
			className={className}
		>
			<path
				d='M12.1429 10.4787H11.3929H12.1429ZM11.9711 12.1396L12.6394 12.4801V12.4801L11.9711 12.1396ZM11.2824 12.8282L11.6229 13.4965L11.6229 13.4965L11.2824 12.8282ZM1.17176 2.71756L1.84001 3.05805L1.84001 3.05805L1.17176 2.71756ZM1.86042 2.0289L1.51992 1.36064L1.51992 1.36064L1.86042 2.0289ZM1.17176 12.1396L0.5035 12.4801L0.5035 12.4801L1.17176 12.1396ZM1.86042 12.8282L1.51992 13.4965L1.51992 13.4965L1.86042 12.8282ZM6.57143 2.60714C6.98564 2.60714 7.32143 2.27136 7.32143 1.85714C7.32143 1.44293 6.98564 1.10714 6.57143 1.10714V2.60714ZM12.8929 7.42857C12.8929 7.01436 12.5571 6.67857 12.1429 6.67857C11.7286 6.67857 11.3929 7.01436 11.3929 7.42857L12.8929 7.42857ZM12.6732 2.38747C12.9661 2.09458 12.9661 1.61971 12.6732 1.32681C12.3803 1.03392 11.9054 1.03392 11.6125 1.32681L12.6732 2.38747ZM6.46967 6.46967C6.17678 6.76256 6.17678 7.23744 6.46967 7.53033C6.76256 7.82322 7.23744 7.82322 7.53033 7.53033L6.46967 6.46967ZM9.14286 0.25C8.72864 0.25 8.39286 0.585786 8.39286 1C8.39286 1.41421 8.72864 1.75 9.14286 1.75V0.25ZM13 1H13.75C13.75 0.585786 13.4142 0.25 13 0.25V1ZM12.25 4.85714C12.25 5.27136 12.5858 5.60714 13 5.60714C13.4142 5.60714 13.75 5.27136 13.75 4.85714H12.25ZM1.75 10.4787V4.37846H0.25V10.4787H1.75ZM9.62153 12.25H3.52132V13.75H9.62153V12.25ZM11.3929 10.4787C11.3929 10.9323 11.3923 11.2275 11.3739 11.4526C11.3562 11.669 11.3259 11.7539 11.3028 11.7991L12.6394 12.4801C12.7881 12.1882 12.8436 11.8839 12.8689 11.5747C12.8934 11.2744 12.8929 10.9076 12.8929 10.4787H11.3929ZM9.62153 13.75C10.0504 13.75 10.4172 13.7506 10.7176 13.726C11.0268 13.7008 11.331 13.6452 11.6229 13.4965L10.9419 12.16C10.8968 12.183 10.8119 12.2133 10.5955 12.231C10.3703 12.2494 10.0752 12.25 9.62153 12.25V13.75ZM11.3028 11.7991C11.2237 11.9545 11.0973 12.0808 10.9419 12.16L11.6229 13.4965C12.0606 13.2735 12.4164 12.9177 12.6394 12.4801L11.3028 11.7991ZM1.75 4.37846C1.75 3.92482 1.75058 3.62969 1.76898 3.40454C1.78666 3.18815 1.81698 3.10325 1.84001 3.05805L0.5035 2.37707C0.354772 2.66896 0.299219 2.97324 0.27396 3.28239C0.249417 3.58279 0.25 3.94957 0.25 4.37846H1.75ZM3.52132 1.10714C3.09243 1.10714 2.72565 1.10656 2.42525 1.1311C2.1161 1.15636 1.81182 1.21192 1.51992 1.36064L2.20091 2.69715C2.2461 2.67413 2.33101 2.6438 2.5474 2.62612C2.77254 2.60773 3.06767 2.60714 3.52132 2.60714V1.10714ZM1.84001 3.05805C1.91918 2.90266 2.04552 2.77633 2.20091 2.69715L1.51992 1.36064C1.08229 1.58363 0.726485 1.93943 0.5035 2.37707L1.84001 3.05805ZM0.25 10.4787C0.25 10.9076 0.249417 11.2744 0.27396 11.5748C0.299219 11.8839 0.354772 12.1882 0.5035 12.4801L1.84001 11.7991C1.81698 11.7539 1.78666 11.669 1.76898 11.4526C1.75058 11.2275 1.75 10.9323 1.75 10.4787H0.25ZM3.52132 12.25C3.06767 12.25 2.77254 12.2494 2.5474 12.231C2.33101 12.2133 2.2461 12.183 2.20091 12.16L1.51992 13.4965C1.81182 13.6452 2.1161 13.7008 2.42525 13.726C2.72565 13.7506 3.09242 13.75 3.52132 13.75V12.25ZM0.5035 12.4801C0.726485 12.9177 1.08229 13.2735 1.51992 13.4965L2.20091 12.16C2.04552 12.0808 1.91918 11.9545 1.84001 11.7991L0.5035 12.4801ZM3.52132 2.60714H6.57143V1.10714H3.52132V2.60714ZM11.3929 7.42857L11.3929 10.4787H12.8929L12.8929 7.42857L11.3929 7.42857ZM11.6125 1.32681L6.46967 6.46967L7.53033 7.53033L12.6732 2.38747L11.6125 1.32681ZM9.14286 1.75H13V0.25H9.14286V1.75ZM12.25 1V4.85714H13.75V1H12.25Z'
				fill='currentColor'
			/>
		</svg>
	);
};
